import { toast } from 'react-toastify';

const baseConfig = {
  position: 'top-center',
  autoClose: 3000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  theme: 'dark'
};

export function showSuccess(message) {
  toast.success(message, {
    ...baseConfig,
    icon: '✅'
  });
}

export function showError(message) {
  toast.error(message, {
    ...baseConfig,
    icon: '❌',
    autoClose: 4000
  });
}

export function showWarning(message) {
  toast.warning(message, {
    ...baseConfig,
    icon: '⚠️'
  });
}

export function showInfo(message) {
  toast.info(message, {
    ...baseConfig,
    icon: 'ℹ️'
  });
}